var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('style',{tag:"component"},[_vm._v(" :root { --primary-color: "+_vm._s(_vm.primaryColor)+"; --primary-hover-color: "+_vm._s(_vm.primaryColor)+"; --background-color: "+_vm._s(_vm.backgroundColor)+"; } ")]),_c('Navbar'),_c('div',{staticClass:"wrapper"},[_c('router-view'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }